import { createFileRoute, Outlet } from "@tanstack/react-router";

import { ErrorPage } from "@/pages/error";

export const Route = createFileRoute("/session")({
  component: SessionLayout,
  errorComponent: ErrorPage,
});

function SessionLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <Outlet />
    </div>
  );
}
